/**
 * Blossom — quick-add.js
 * Opens the global quick add modal (#QuickAddModal, rendered in
 * layout/theme.liquid) for multi-variant products. Any element with
 * data-quick-add="<product url>" (see snippets/quick-add.liquid) triggers it.
 *
 * Flow: open modal → loading state → sections/quick-add.liquid is fetched
 * through the Section Rendering API → product scripts load → the visitor picks
 * a shade and adds to bag (<product-form> closes the modal and opens the cart).
 * On errors the modal shows a message and a link to the product page.
 * Without JavaScript (or with a modified click) the trigger is a normal link.
 *
 * Emits theme:quick-add:open { url, trigger }.
 */
(() => {
  if (!window.Theme || window.Theme.quickAddBound) return;
  Theme.quickAddBound = true;

  const loadScripts = (container) => {
    const holder = container?.querySelector('[data-quick-add-scripts]');
    if (!holder) return Promise.resolve();
    const sources = (holder.dataset.quickAddScripts || '').split(',').map((src) => src.trim()).filter(Boolean);
    return Promise.all(sources.map((src) => Theme.loadScript(src))).catch((error) => {
      console.warn('[quick-add] Could not load product scripts.', error);
    });
  };

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-quick-add]');
    if (!trigger) return;
    // Let modified clicks (new tab/window) behave like normal links.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    const modal = document.getElementById('QuickAddModal');
    if (!modal || typeof modal.loadSection !== 'function') return;

    event.preventDefault();
    const url = trigger.dataset.quickAdd || trigger.getAttribute('href');
    if (!url) return;

    trigger.setAttribute('aria-busy', 'true');
    modal.open(trigger);
    Theme.emit(Theme.events.QUICK_ADD_OPEN, { url, trigger });

    const content = await modal.loadSection({
      url,
      sectionId: 'quick-add',
      selector: '[data-quick-add-content]',
      fallbackUrl: url,
    });
    trigger.removeAttribute('aria-busy');
    if (content) await loadScripts(content);
  });
})();
